export const CANCEL_CRAWLING = 'CANCEL_CRAWLING'
export const CRAWL_REDIRECT = 'CRAWL_REDIRECT'
export const DISCARD_CRAWL = 'DISCARD_CRAWL'

export const NEW_CRAWLING = 'NEW_CRAWLING'
export const STOP_CRAWLING = 'STOP_CRAWLING'
export const UNSAVED_CHANGES = 'UNSAVED_CHANGES'
export const DELETE_TEAM_AVATAR = 'DELETE_TEAM_AVATAR'
export const DELETE_AVATAR = 'DELETE_AVATAR'
export const DELETE_FILE = 'DELETE_FILE'

export const DELETE_TAB_DIALOG = 'DELETE_TAB_DIALOG'

export const GENERAL_CONFIRMATION = 'GENERAL_CONFIRMATION'
